import { render, staticRenderFns } from "./ChoicePage.vue?vue&type=template&id=77d737af&scoped=true&"
import script from "./ChoicePage.vue?vue&type=script&lang=js&"
export * from "./ChoicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d737af",
  null
  
)

export default component.exports